import React, { useEffect, useState } from 'react';
import Toast from 'devextreme-react/toast';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { ARCHIVED, COMMERCIALLY_FOLLOWED_UP_STATUS, TO_BE_INVOICED_STATUS, TO_SCHEDULE_STATUS, WAITING_FOR_REPLY, WAITING_VIDEOS_PHOTOS } from '../../../../constants/constants';
import { Button } from 'devextreme-react/button';
import CloseIcon from '@material-ui/icons/Close';
const styles = (theme) => ({
    toastContainer: {
        // '& .dx-toast-icon': {
        //     display: 'none'
        // },
        // '& .dx-overlay-content': {
        //     left: '16px!important',
        //     bottom: '16px!important',
        //     backgroundColor: '#4caf50!important',
        //     height: 'fit-content !important',
        //     width: 'fit-content !important',
        //     top: 'unset!important',
        //     transform: 'none!important',
        //     '& .toastContent': {
        //         '& .toastItem': {
        //             display: 'flex',
        //             gap: '16px',
        //             margin: '8px 0',
        //             alignItems: 'center',
        //             '& .toastItemText': {
        //                 flex:1
        //             }
        //         },
        //         '& .btnCancel': {
        //             fontWeight: '700!important',
        //             fontSize: '18px!important',
        //             padding: '8px 16px!important',
        //             '& .dx-button-content': {
        //                 color: '#605e72!important'
        //             }
        //         },
        //         '& .btnClose': {
        //             backgroundColor: 'transparent',
        //             border: 'none',
        //             color: '#fff'
        //         }
        //     }
        // }
    }
})
const useStyles = makeStyles(styles);

const HistoryChangeStatusToast = ({history, onRemoveItems,onCancel}) => {
    const {t} = useTranslation();
    const classes = useStyles();

    useEffect(() => {
        if (history.length === 0) return;
        const interval = setInterval(() => {
          const now = Date.now();
          const removeItems = history.filter((toast) => now - toast.toastTime > 30000);
          if (removeItems.length) {
            onRemoveItems(removeItems)
          }
        }, 1000);
    
        return () => clearInterval(interval);
      }, [history]);

    const labelByStatus = {
        [TO_BE_INVOICED_STATUS]: t("request.status.TO_BE_INVOICED"),
        [ARCHIVED]: t("request.status.archived"),
        [TO_SCHEDULE_STATUS]: t("request.status.TO_SCHEDULE"),
        [COMMERCIALLY_FOLLOWED_UP_STATUS]: t("request.status.COMMERCIALLY_FOLLOWED_UP"),
        [WAITING_FOR_REPLY]: t("request.status.TO_PROCESS"),
        [WAITING_VIDEOS_PHOTOS]: t("request.status.WAITING_VIDEOS_PHOTOS"),
    }
    if (history.length === 0) {
        return <></>
    }
  return (
    <Toast
        visible={true}
        displayTime={10000000}
        className={`${classes.toastContainer}  history-change-status-toast-wrapper`}
        // className={classes.toastContainer}
    >
        <div className='toastContent'>
            {
                history.map(item => {
                    return (
                       <div className='toastItem' key={item.toastTime}>
                            <div className='toastItemText'>
                                {t('request.list.request_changed_status', {
                                    id: item.id,
                                    status_1: labelByStatus[item.status?.statusType?.code]?? "",
                                    status_2: labelByStatus[item.dialogType] ?? ""
                                })}
                                {/* {`Request #${item.id} đã thay đổi status từ ${labelByStatus[item.status?.statusType?.code]?? ""} -> ${labelByStatus[item.dialogType] ?? ""}`} */}
                            </div>
                            {   
                            item.disableCancel 
                            ?
                            <div>

                            </div>
                            :
                            <Button
                                onClick={() => {
                                    onCancel && onCancel(item)
                                }}
                                className='btnCancel'
                            >
                                {t('button.cancel')}
                            </Button>
                            }
                            <Button className='btnClose' onClick={() => {
                                onRemoveItems && onRemoveItems([item])
                            }}>
                                <CloseIcon />
                            </Button>
                       </div>
                    )
                })
            }
        </div>
    </Toast>
  );
};

export default HistoryChangeStatusToast;
